"use strict";

import "../../scss/pages/map-index.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";

import { translationCountryNames } from '../helpers/TranslationCountries';
import axios from "axios";
import GlobalError from "../helpers/globalError";
import ToggleDarkMode from "../helpers/ToggleDarkMode";
import ModalDownloadMobileApp from "../components/modal-download-mobile-app";

document.addEventListener("DOMContentLoaded", function () {
	const searchParams = new URLSearchParams(window.location.search);
	const containerInitMessage = document.querySelector('.container-init-message');
	const progressBar = containerInitMessage.querySelector('.progress-init-bar');
	const message = containerInitMessage.querySelector('.init-content');
	const mapVersion = searchParams.get('v') ? parseInt(searchParams.get('v')) : 0;
	const geoInfo = window.location.pathname.split('/')[4];
	let progress = 0;
	const main = document.querySelector('.container-page');
	
	if (((sessionStorage.getItem('modalDownloadAppShown') !== 'true') && main) && ((main.dataset.deviceType === 'Mobile Device') || (main.dataset.deviceType === 'Mobile Phone'))) {
		import('../components/modal')
			.then((module) => {
				
				const params = {
					deviceType: main.dataset.deviceType
				}
				const modalModule = new module.Modal();
				modalModule.openModal('modal-download-mobile-app modal-auth modal-slide-up', 'modalDownloadMobileApp', './modal/modal-download-mobile-app', params, ModalDownloadMobileApp.handleOnOpen, ModalDownloadMobileApp.activeSession);
			})
	}
	
	setTimeout(() => {
		if (progressBar) {
			progressBar.parentNode.classList.remove('d-none');
		}
		message.textContent = message.dataset.transMessage;
		containerInitMessage.progress = 50;
		progressBar.style.width = `${ progress }%`;
	}, 2000);
	
	setTimeout(() => {
		
		const mapTypeActions = {
			'country': true,
			'isp': true,
			'mapType': true,
			'fullscreen': true,
			'search': true
		}
		
		const languageSelected = document.querySelector('#dropdownlanguageMenu');
		const config = {
			onUploadProgress: (progressEvent) => {
				const {loaded, total} = progressEvent;
				progress = Math.round((loaded * 100) / total);
				progressBar.style.width = `${ progress }%`;
			}
		}
		
		axios.post(`/${ languageSelected.dataset.languageSelected }/map/load-map-component`, {
				mapType: 'ALL',
				mapVersion: mapVersion,
				typeActionsMap: mapTypeActions,
				geoId: geoInfo !== '-' ? parseInt(geoInfo.split('.')[0]) : 0,
			}, config)
			.then(((response) => {
				const containerModuleMap = document.querySelector('.container-module-map');
				if (progress === 100) {
					containerModuleMap.classList.add('anim-module');
					containerInitMessage.classList.add('anim-container-init');
					containerModuleMap.innerHTML = response.data;
				}
				const switchThemeMode = document.querySelector('#toggleColorMode');
				const lightModeImageList = document.querySelectorAll('.light-mode-img');
				const darkModeImageList = document.querySelectorAll('.dark-mode-img');
				
				if (darkModeImageList.length > 0) {
					
					ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
					
					switchThemeMode.addEventListener('click', () => {
						ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
					});
				}
				
				import('bootstrap4.3.1/js/dist/button')
					.then()
					.catch(() => 'An error occurred while loading the component');
				
				import('../components/map')
					.then((module) => {
						const mapModule = new module.Map();
						import('bootstrap4.3.1/js/dist/button')
							.then()
							.catch(() => 'An error occurred while loading the component');
						const containerMapElement = document.querySelector('.container-select-map');
						mapModule.selectMapTypeButton();
						mapModule.initializeMap('signal').then(() => {
								
								mapModule.getCountryList();
								
								containerMapElement.addEventListener("fullscreenchange", () => {
									if (!document.fullscreenElement) {
										mapModule.displayFullScreenElements(containerMapElement, false);
									}
								});
								const regionName = translationCountryNames();
								
								new TomSelect("#selectMapCountry", {
									create: false,
									labelField: 'Iso3166',
									valueField: 'Iso3166',
									hidePlaceholder: false,
									allowEmptyOption: true,
									placeholder: 'Country',
									plugins: ['dropdown_input'],
									maxOptions: null,
									searchField: ['IsoName', 'Iso3166'],
									hideSelected: true,
									selectOnTab: false,
									closeAfterSelect: true,
									maxItems: 1,
									render: {
										item: function (item, escape) {
											return '<div data-minlat="' + escape(item.MinLat) + '" data-minlng="' + escape(item.MinLng) + '" data-maxlat="' + escape(item.MaxLat) + '" data-maxlng="' + escape(item.MaxLng) + '">' +
												'<span class="flag" ><span class="fi fi-' + escape(item.Iso3166) + ' fib"></span></span>' +
												'<span class="name">' + escape(item.Iso3166.toUpperCase()) + ' <span class="d-none d-sm-inline"> - ' + escape(regionName.of(item.Iso3166.toUpperCase())) + '</span></span>' +
												'<span class="name-rtl">' + escape(item.Iso3166.toUpperCase()) + '<span class="d-none d-sm-inline"> - ' + escape(regionName.of(item.Iso3166.toUpperCase())) + '</span></span>' +
												'</div>';
										},
										option: function (item, escape) {
											const countryCode = item.Iso3166 === 'reset' ? item.Iso3166.toUpperCase() : regionName.of(item.Iso3166.toUpperCase());
											return '<div <div data-minlat="' + escape(item.MinLat) + '" data-minlng="' + escape(item.MinLng) + '" data-maxlat="' + escape(item.MaxLat) + '" data-maxlng="' + escape(item.MaxLng) + '">' +
												'<span class="flag"><span class="fi fi-' + escape(item.Iso3166) + ' fib"></span></span>' +
												'<span class="name">' + escape(item.Iso3166.toUpperCase()) + ' - ' + countryCode + '</span>' +
												'<span class="name-rtl">' + escape(item.Iso3166.toUpperCase()) + ' - ' + countryCode + '</span>' +
												'</div>';
										}
									},
									onChange: function (event) {
										if (event.length !== 0) {
											mapModule.getIspList();
										} else {
											mapModule.updateHeaderComponent();
											mapModule.updateDescriptionComponent();
										}
									}
								});
								
								new TomSelect("#selectMapIsp", {
									create: false,
									labelField: 'IspId',
									valueField: 'IspId',
									allowEmptyOption: true,
									hidePlaceholder: true,
									plugins: ['dropdown_input'],
									searchField: ['IspName'],
									placeholder: 'Carrier',
									maxOptions: null,
									hideSelected: true,
									closeAfterSelect: true,
									maxItems: 1,
									render: {
										item: function (item, escape) {
											return '<div data-isp-name="' + escape(item.IspName) + '">' +
												'<i class="fa-solid fa-sim-card"></i>' +
												'<span class="name text-ellipsis">' + escape(item.IspName) + '</span>' +
												'</div>';
										},
										option: function (item, escape) {
											return '<div data-isp-name="' + escape(item.IspName) + '">' +
												'<span class="name">' + escape(item.IspName) + '</span>' +
												'</div>';
										}
									},
									onChange: function () {
										mapModule.updateUrl(false, false);
										mapModule.updateHeaderComponent();
										mapModule.updateDescriptionComponent();
										mapModule.toggleOverlay();
									},
								});
								mapModule.mapRef.on('dragend', () => {
									const urlParams = new URLSearchParams(window.location.search);
									const geoInfo = mapModule.getGeolocationInformations(mapModule.mapRef);
									urlParams.set('ll', geoInfo.latitude);
									urlParams.set('lg', geoInfo.longitude);
									urlParams.set('zoom', geoInfo.zoom);
									history.replaceState({nPerf: 'map'}, '', `${ location.pathname }?${ urlParams.toString() }`);
								});
								const mapCanvas = document.querySelector('#map');
								mapCanvas.addEventListener('wheel', (event) => {
									event.stopPropagation();
									if (event.ctrlKey) {
										event.preventDefault();
										mapModule.mapRef.scrollWheelZoom.enable();
										mapModule.updateUrl(false, true);
									} else {
										mapModule.mapRef.scrollWheelZoom.disable();
									}
								})
							}
						);
						
						const toggleMapType = mapModule.toggleMapType.bind(mapModule);
						let mapTypeButtonList = document.querySelectorAll('.btn-map-type');
						[...mapTypeButtonList].forEach(el => el.addEventListener('click', toggleMapType));
						
						new TomSelect("#inputMapSearch", {
							labelField: 'placeId',
							valueField: 'placeId',
							persist: false,
							createOnBlur: false,
							create: false,
							maxItems: 1,
							maxOptions: null,
							searchField: ['name'],
							hideSelected: true,
							load: function (query, callback) {
								mapModule.getResultSearchList(query, callback);
							},
							render: {
								item: function (item, escape) {
									return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
										'<span class="name">' + escape(item.name) + '</span>' +
										'</div>';
								},
								option: function (item, escape) {
									return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
										'<i class="' + escape(item.iconName) + '"></i>' +
										'<span class="name">' + escape(item.name) + '</span>' +
										'</div>';
								}
							},
							onChange: function () {
								mapModule.refreshMap();
								mapModule.refreshSearchOptions();
							},
							onDropdownOpen: function () {
								mapModule.refreshSearchOptions();
							}
						});
						
						new TomSelect("#selectTileMap", {
							labelField: 'value',
							valueField: 'value',
							allowEmptyOption: true,
							maxOptions: null,
							create: false,
							options: [
								{value: "arcGis", text: "ArcGIS"},
								{value: "openStreetMap", text: "OpenStreetMap"},
								{value: "hereWeGo", text: "here WeGo"},
							],
							controlInput: null,
							items: ['arcGis'],
							hideSelected: true,
							render: {
								item: function (item, escape) {
									return '<div data-tile-name="' + escape(item.value) + '" aria-label="' + escape(item.value) + '">' +
										'<span class="name">' + escape(item.text) + '</span>' +
										'</div>';
								},
								option: function (item, escape) {
									return '<div data-tile-name="' + escape(item.value) + '"  aria-label="' + escape(item.value) + '">' +
										'<span class="name">' + escape(item.text) + '</span>' +
										'</div>';
								}
							},
							onChange: function (event) {
								mapModule.toggleTileMap(event, 'signal');
							}
						});
						
						const buttonFullScreenList = document.querySelectorAll('.btn-full-screen');
						buttonFullScreenList.forEach((buttonFullScreen) => {
							buttonFullScreen.addEventListener('click', () => {
								mapModule.toggleFullscreen();
							});
						});
						
					})
					.catch((error) => {
						console.error("Error loading module:", error);
					});
				
			}))
			.catch((error) => {
				if (error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalErrorMap');
				}
			});
	}, 2500);
	
	const buttonMapMobileApp = document.querySelectorAll('.btn-map-app');
	buttonMapMobileApp.forEach((mapStoreApp) => {
		mapStoreApp.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'MapMobileApp', mapStoreApp.dataset.tag]);
			/* eslint-enable */
		})
	});
	
});